import React from 'react';
import { Container, StyledHeader, HeaderLogo, Menu, Nav, NavMenu, NavItem, CTAs, IconsGroup, Icon, IconStart, IconClose,
    SearchBar, SearchForm, SideNavContainer, ButtonsGroup, LoggedIn, User, UserImage, UserMenu, FirstName, LogOut, Login, CampaingButtons, CampaingBtn } from './header.style';
import MainNav from './MainNav/MainNav';
import SideNav from './SideNav/SideNav';
import LanguageBar from './LanguageBar/LanguageBar';
import  { Link } from 'react-router-dom';
import DropdownButton from 'components/common/Button/DropdownButton';
import {CMSContext, ConfigContext} from 'context/AppContext';
import helper from 'components/utils/helper';
import SearchInput from './SearchInput/searchInput'
import { Accessibility } from 'components/common';

const Header = () => {
    let CmsContext = React.useContext(CMSContext);
    const [cms] = React.useState(CmsContext);

    let configContext = React.useContext(ConfigContext);
    let config = configContext.config;

    const [activeMenu, setActiveMenu] = React.useState(null);
    const [isHoverNav, setIsHoverNav] = React.useState(false);
    const [searching, setSearching] = React.useState(false);
    const [loggedIn, setLoggedIn] = React.useState(helper.getCookie('movember-produs-2016_logged') === '1');
    const [userMenuVisible, setUserMenuVisible] = React.useState(false);
    const { ref, isComponentVisible, setIsComponentVisible } = helper.useComponentVisible(false);
    const isOnMobile = helper.isOnMobile();
    const [headerHeight, setHeaderHeight] = React.useState((isOnMobile && !loggedIn) ? '138px' : '75px');
    // Close user menu when click outside of the menu
    const clickOutsideWrapperRef = React.useRef(null);
    helper.useClickOutside(clickOutsideWrapperRef, () => setUserMenuVisible(false));

    let logoDesktop = (cms.siteSettings && cms.siteSettings.logoDesktop && cms.siteSettings.logoDesktop.url) 
    ? cms.siteSettings.logoDesktop.url : '/resources/images/global/movember_logo_primary.svg',
    logoMobile = (cms.siteSettings && cms.siteSettings.logoMobile && cms.siteSettings.logoMobile.url) 
    ? cms.siteSettings.logoMobile.url : '/resources/images/global/movember_logo.png',
    loginText = cms.siteSettings.campaignButtons.login.text,
    loginUrl = cms.siteSettings.campaignButtons.login.url,
    registerText = cms.siteSettings.campaignButtons.register.text,
    registerUrl = cms.siteSettings.campaignButtons.register.url,
    donateText = cms.siteSettings.campaignButtons.donate.donateBtn.text,
    donateOptions = [
        {
            text: cms.siteSettings.campaignButtons.donate.giveOnceBtn.text,
            url: cms.siteSettings.campaignButtons.donate.giveOnceBtn.url
        },
        {
            text: cms.siteSettings.campaignButtons.donate.giveMonthlyBtn.text,
            url: cms.siteSettings.campaignButtons.donate.giveMonthlyBtn.url
        },
        {
            text: cms.siteSettings.campaignButtons.donate.giveToAPersonBtn.text,
            url: cms.siteSettings.campaignButtons.donate.giveToAPersonBtn.url
        }
    ];

  

    React.useEffect(() => {
         // Remove the Give Monthly Donation option if not enabled in our configs
        if (config.getValue("donation.recurring.enabled").indexOf(config.getCountry()) < 0) {
            donateOptions.splice(1,1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if(helper.getCookie(helper.getUserCookieName('logged')) === '1'){
            setLoggedIn(true);
            // Header default height
            setHeaderHeight('75px'); 
        }
    }, [loggedIn]);

    function getUrl(url) {
        return (config.getLanguage() !== 'en') ? `/${config.getLanguage() + url}` : url;
    }

    function loggingOut() {
        fetch(`${helper.getLegacyAssetUrl('api', '/auth', config.getCountry() )}`, {method: 'DELETE'})
        .then(res => res.json())
        .then(
            success => {
                if(success.result){
                    setLoggedIn(false);
                    // Header height on mobile
                    setHeaderHeight(isOnMobile  ? '138px' : '75px');
                }
            },
            error => {
                console.log("Request error " + error);
            }
        ); 
    };

    function getUserInfo(info){
        switch(info){
            default:
            case 'firstname':
                let fullname = helper.getCookie(helper.getUserCookieName('name'));
                return fullname ? fullname.split('+')[0] : '';
            case 'image':
                let imageObj = decodeURIComponent(helper.getCookie(helper.getUserCookieName('pic')));
                return imageObj ? imageObj : null;
        }
    }
  
    return (
        <Container height={headerHeight}>
            <StyledHeader name="StyledHeader">
                <Accessibility/>
                <HeaderLogo name="HeaderLogo" logo={logoDesktop} logoMobile={logoMobile}>
                    <Link to={getUrl('/')}></Link>
                </HeaderLogo>
                <Menu name="Menu">
                    <CTAs name="CTAs">
                        <IconsGroup name="IconsGroup">
                            <Icon isSideMenu={true}>
                                <IconStart isVisible={!isComponentVisible} isSideMenu={true} onClick={()=> setIsComponentVisible(true)}/>
                                <IconClose isVisible={isComponentVisible} onClick={()=> setIsComponentVisible(false)}/>
                                 
                            </Icon>
                            <Icon IconStart>
                                <IconStart name="IconStart" isVisible={!searching} onClick={() => setSearching(true)}/>
                                <IconClose isVisible={searching} onClick={() => setSearching(false)}/>
                            </Icon>
                        </IconsGroup>
                        <ButtonsGroup name="ButtonsGroup">
                            {loggedIn ? 
                            <LoggedIn>
                                <User name="User" onClick={() => setUserMenuVisible(!userMenuVisible)}>
                                    <FirstName name="FirstName">{getUserInfo('firstname')}</FirstName>
                                    <UserImage name="UserImage">
                                        <img  src={getUserInfo('image') ? helper.getBaseUrl(config.getCountry()) + getUserInfo('image') : null} alt="user-profile"/>
                                    </UserImage>
                                    <UserMenu isVisible={userMenuVisible} ref={clickOutsideWrapperRef}>
                                        { (cms.nav && cms.nav.loggedInMenu) &&
                                            <ul>
                                                {Object.keys(cms.nav.loggedInMenu).map(item => 
                                                    <React.Fragment key={item}>
                                                        {item === 'logOut' ?
                                                         // eslint-disable-next-line
                                                         <LogOut><a onClick={()=> loggingOut()}>{cms.nav.loggedInMenu[item].text}</a></LogOut>
                                                         :<li><a href={getUrl(cms.nav.loggedInMenu[item].link)}>{cms.nav.loggedInMenu[item].text}</a></li>
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </ul>
                                        }
                                    </UserMenu>
                                </User>
                            </LoggedIn>
                            : <Login name="Login" href={loginUrl}>{loginText}</Login>}
                            { !(loggedIn && isOnMobile) &&
                                <CampaingButtons name="CampaingButtons">
                                    {!loggedIn && <CampaingBtn name="CampaingBtn" href={registerUrl}>{registerText}</CampaingBtn>}
                                    <DropdownButton text={donateText} options={donateOptions} />
                                </CampaingButtons>
                            }
                        </ButtonsGroup>
                    </CTAs>
                    <Nav>
                        <NavMenu  name="NavMenu" id="header-nav">
                            {(typeof cms.nav.siteNav === 'object') && Object.keys(cms.nav.siteNav).map(menu =>
                                <React.Fragment key={menu}>
                                    <NavItem name="NavItem">
                                        {/* eslint-disable-next-line */}
                                        <a href="#" onMouseEnter={()=> { setActiveMenu(menu !== 'stories' ? cms.nav.siteNav[menu].categories : cms.nav.siteNav[menu]); setIsHoverNav(true)}}
                                            onMouseLeave={()=> setIsHoverNav(false)}>
                                                {cms.nav.siteNav[menu].title}
                                        </a>
                                    </NavItem>
                                </React.Fragment>
                            )}
                        </NavMenu>
                        <MainNav activeMenu={activeMenu} isHoverNav={isHoverNav}/>
                    </Nav>
                </Menu>
            </StyledHeader>

            <SideNavContainer ref={ref}>
                <SideNav isVisible={isComponentVisible} nav={cms.nav.siteNav} loggedIn={loggedIn} headerHeight={headerHeight}/>
            </SideNavContainer>
           
            <SearchBar name="SearchBar" isVisible={searching} headerHeight={headerHeight}>
                <SearchForm>
                    <SearchInput placeholder="Search"/>
                </SearchForm>
            </SearchBar>
            <LanguageBar isVisible={true}/>
        </Container>
    );
}

export default Header;